module.exports = {
	"common": {
		"title": "Новостройки - Nedvex",
		"jk": "ЖК",
		"kp": "КП",
		"stopped": "Продажи остановлены"
	},
	"constants": {
		"view_type": {
			"filter": {
				"intoYard": "Двор",
				"toMountains": "Горы",
				"onSea": "Море",
				"toPark": "Парк",
				"toGarden": "Сад",
				"toForest": "Лес",
				"onSocialObjects": "Социальные объекты",
				"panoramicView": "Панорамный вид"
			},
			"rightMenu": {
				"intoYard": "Вид во двор",
				"toMountains": "Вид на горы",
				"onSea": "Вид на море",
				"toPark": "Вид на парк",
				"toGarden": "Вид на сад",
				"toForest": "Вид на лес",
				"onSocialObjects": "Вид на социальные объекты",
				"panoramicView": "Панорамный вид"
			}
		},
		"apartments": {
			"studioAp": "Студия",
			"oneAp": "1-к",
			"twoAp": "2-к",
			"threeAp": "3-к",
			"allAp": "4+",
			"penthaus": "Пентхаус"
		},
		"interiors": {
			"all": "Любая",
			"chernInt": "Черновая",
			"chistInt": "Чистовая",
			"whiteBox": "White box",
			"repair": "Ремонт, мебель, техника",
			"predChistInt": "Пред. чистовая",
			"remInt": "Ремонт",
			"chastRemInt": "Частичный ремонт"
		},
		"features": {
			"concierge": "Консьерж",
			"elevator": "Лифт",
			"children_area": "Детская площадка",
			"landscape_decore": "Ландшафтный дизайн",
			"sport_area": "Спортивная площадка",
			"spa": "SPA",
			"fitness": "Фитнес",
			"pool": "Бассейн",
			"kindergarten": "Детский сад",
			"tennis_court": "Теннисный корт",
			"recreation_zone": "Зона отдыха",
			"fountain": "Фонтан",
			"garden": "Сад",
			"helicopter_landing_area": "Вертолетная площадка",
			"commercial_property": "Коммерческие площади",
			"cctv_surveillance": "Видеонаблюдение",
			"kpp": "КПП",
			"restaurant": "Ресторан",
			"billiards": "Бильярд",
			"sauna": "Сауна",
			"is_children_room": "Детская комната",
			"is_conference_hall": "Конференц зал",
			"is_wellness_building": "Оздоровительный корпус",
			"is_panoramic_glazing": "Панорамное остекление",
			"is_beach": "Пляж",
			"is_walking_area": "Прогулочные зоны",
			"is_operated_roof": "Эксплуатируемая кровля",
			"is_garage": "Гараж",
			"is_acs_system": "Система СКУД",
			"is_landscape_park": "Ландшафтный парка",
			"is_management_company": "Управляющая компания"
		},
		"variants": {
			"selectMicro": "Выберите микрорайон",
			"central": {
				"title": "Центральный",
				"checkboxes": {
					"1": "Донская",
					"2": "Завокзальный",
					"3": "Заречный",
					"4": "КСМ",
					"5": "Макаренко",
					"6": "Мамайка низ",
					"7": "Мамайка верх",
					"8": "Новый Сочи",
					"9": "Клубничная",
					"10": "Центр"
				}
			},
			"hostinskii": {
				"title": "Хостинский",
				"checkboxes": {
					"11": "Ахун",
					"12": "Бытха",
					"13": "Кудепста пос.",
					"14": "Мацеста",
					"15": "Приморье",
					"16": "Раздольное",
					"17": "Светлана низ",
					"18": "Светлана верх",
					"19": "Соболевка",
					"20": "Фабрициуса",
					"21": "Хоста",
					"22": "Транспортная"
				}
			},
			"adler": {
				"title": "Адлерский",
				"checkboxes": {
					"23": "Адлер-центр",
					"24": "Блиново",
					"25": "Веселое село",
					"26": "Голубые Дали",
					"27": "Красная Поляна пос.",
					"28": "Курортный городок",
					"29": "Мирный",
					"30": "Молдовка село",
					"31": "Орел-Изумруд село",
					"32": "Южные культуры",
					"33": "Имеретинская низменность"
				}
			},
			"lazar": {
				"title": "Лазаревский",
				"checkboxes": {
					"34": "Лоо пос.",
					"35": "Дагомыс пос.",
					"36": "Лазаревское пос."
				}
			},
			"tuapse": {
				"title": "Туапсе",
				"checkboxes": {
					"37": "Туапсе"
				}
			}
		}
	},
	"components": {
		"support": {
			"title": "Техподдержка",
			"whatsup": "What’s App",
			"telegram": "Telegram",
			"email": "Написать на почту"
		},
		"blocker": {
			"admin": {
				"title": "Доступ для «{{agencyName}}» приостановлен",
				"description": "{{tarif}} период подошел к концу. Для восстановления доступа свяжитесь с менеджером Nedvex",
				"manager": {
					"phone": "+7 (968) 300-01-12",
					"name": "Техническая поддержка"
				}
			},
			"worker": {
				"title": "Доступ для «{{agencyName}}» приостановлен",
				"description": "{{tarif}} период подошел к концу. Для возобновления работы обратитесь к администратору «{{agencyName}}»."
			},
			"individual": {
				"title": "Доступ приостановлен",
				"description": "{{tarif}} период подошел к концу. Для восстановления доступа перейдите к оплате",
				"pay": "Перейти к оплате"
			}
		},
		"appointment": {
			"appointmentButton": {
				"button": "Записаться на показ"
			},
			"buildingAppointment": {
				"title": "Ближайшая запись на показ"
			},
			"appointmentDialog": {
				"stepOneTitle": "ВЫБЕРИТЕ ВРЕМЯ",
				"stepTwoTitle": "ЗАПОЛНИТЕ ДАННЫЕ",
				"nextButton": "Далее",
				"submitButton": "Записаться",
				"appointmentForm": {
					"generalInfo": "Общая информация",
					"clientName": "Имя клиента",
					"clientNumber": "Последние 4 цифры номера клиента",
					"comment": "Дополнительный комментарий (максимум 250 символов)",
					"selectedDate": "Выбранная дата",
					"clientNameRequired": "Введите имя клиента",
					"clientNumberRequired": "Введите последние 4 цифры номера клиента"
				},
				"availableSlots": "Свободное время",
				"noAvailableSlotsTitle": "Нет доступных слотов",
				"noAvailableSlotsSubtitle": "Воспользуйтесь записью в другой день или свяжитесь с менеджером отдела продаж",
				"resultSuccessTitle": "Мы отправили запрос на просмотр объекта",
				"resultSuccessText": "С вами свяжется застройщик в ближайшее время и согласует просмотр. После подтверждения вам придёт пуш-уведомление в приложении",
				"resultSuccessGood": "Хорошо",
				"resultSuccessToMyAppointment": "В мои записи",
				"resultErrorTitle": "Не удалось записаться",
				"resultErrorText": "Попробуйте ещё раз, если не поможет перезайдите попозже",
				"resultErrorNewAppointment": "Перезаписаться",
				"resultErrorClose": "Закрыть"
			}
		},
		"building": {
			"bar": {
				"finished": "сдан",
				"inProcess": "строится",
				"infoAboutKP": "Информация о КП",
				"infoAboutJK": "Информация о ЖК",
				"today": "Сегодня",
				"pavilion": "Корпус",
				"section": "секция",
				"dateUpdated": "Дата обновления шахматки",
				"dateFrom": "Шахматка от",
				"list": "Список",
				"listTooltip": "Посмотреть квартиры на шахматке",
				"chess": "Шахматка",
				"chessTooltip": "Посмотреть квартиры списком"
			},
			"filters": {
				"price": "Цена",
				"area": "Площадь",
				"inter": "Отделка",
				"housing": {
					"pavilion": "Корпус",
					"section": "секция",
					"finished": "СДАН",
					"inProgress": "СТРОИТСЯ",
					"selectPavilion": "Выбор корпуса"
				}
			},
			"list": {
				"number": "№",
				"numberS": "№",
				"name": "№",
				"nameS": "№",
				"area": "Площадь",
				"areaS": "S",
				"cost": "Цена",
				"costS": "Цена",
				"price": "За м²",
				"priceS": "За м²",
				"interior": "Отделка",
				"interiorS": "Отделка",
				"apartments": "Комнат",
				"apartmentsS": "Комн",
				"floor": "Этаж",
				"floorS": "Этаж",
				"floorKp": "Этаж",
				"floorKpS": "Этаж",
				"promo": "Акция",
				"reserv": "Бронь",
				"assign": "Переуступка",
				"soldOutTitle": "Все лоты проданы",
				"soldOutAlt": "Все квартиры проданы",
				"cellWithoutReserved": "Квартиры под запрос ({{cellWithoutReserved}})",
				"otherCells": "Остальные квартиры ({{otherCells}})"
			},
			"rightMenu": {
				"addToCollection": "В подборку",
				"attic": "Мансарда",
				"area": "{{area}} м²",
				"corps": "Корпус",
				"floor": "этаж",
				"cost": "{{costFormatted}} {{currency}}",
				"section": "секция",
				"reserved": "Квартира зарезервирована <br />застройщиком",
				"sold": "Квартира продана",
				"promo": "Акция",
				"reserve": "Бронь",
				"assign": "Переуступка",
				"price": "{{priceFormatted}} {{currency}}/м²",
				"predChistInt": "Пред. чистовая",
				"floorNumber": "{{number}} эт.",
				"flatReserved": "КВАРТИРА ЗАРЕЗЕРВИРОВАНА <br />застройщиком",
				"houseReserved": "ДОМ ЗАРЕЗЕРВИРОВАН <br />застройщиком",
				"zoomImg": "Увеличить планировку",
				"print": "Печать информации о квартире",
				"emptyPlanning": "Отсутствует планировка этажа",
				"priceForM2": "{{currency}}/м²",
				"totalArea": "{{totalArea}} сот. - площадь участка"
			},
			"tableOptions": {
				"tip": "Шахматка с подробной информацией о квартирах",
				"checkbox": "Расширенная шахматка"
			},
			"chess": {
				"title": "{{building}} - Квартиры в ЖК - Nedvex"
			},
			"main": {
				"about": {
					"houseParking": "придомовой",
					"parkingUnderground": "подземный",
					"parkingMultilevel": "многоуровневый",
					"parkingTypeRoofed": "закрытый",
					"noParking": "отсуствует",
					"commonInfo": "Общие характеристики",
					"info": "Характеристики",
					"class": "Класс дома",
					"material": "Материал здания",
					"type": "Тип дома",
					"houseRoad": "Подъезд к дому",
					"parking": "Паркинг",
					"territory": "Территория",
					"distanceSea": "Расстояние до моря",
					"meters": "м.",
					"cealingHeight": "Высота потолков",
					"serviceCost": "Стоимость обслуживания",
					"cost": "{{currency}} / м²",
					"communication": "Коммуникации",
					"gas": "Газ",
					"heating": "Отопление",
					"electricity": "Электричество",
					"sewage": "Канализация",
					"water": "Водоснабжение"
				},
				"chessLink": {
					"seeChess": "Шахматка",
					"seeList": "Шахматка",
					"chess": "Шахматка",
					"list": "Список домов"
				},
				"inaccuracyReport": {
					"add": "Сообщить о неточности"
				},
				"inaccuracyReportDialog": {
					"title": "СООБЩИТЬ О НЕТОЧНОСТИ",
					"subtitle": "Ваш комментарий",
					"textAreaPlaceholder": "Опишите подробнее неточность",
					"button": "Отправить",
					"noCharsLeft": "Осталось 0 символов",
					"reportSended": "Спасибо, Ваше обращение принято!",
					"done": "Хорошо"
				},
				"collections": {
					"add": "В подборку"
				},
				"collectionDialog": {
					"finished": "сдан",
					"almostFinished": "Частично сдан",
					"finishedBIG": "СДАН",
					"inProgress": "СТРОИТСЯ",
					"add": "Добавить в подборку",
					"total": "{{total}} ЖК",
					"createNew": "СОЗДАЙТЕ НОВУЮ ПОДБОРКУ",
					"enterName": "Введите название новой подборки",
					"button": "Создать подборку",
					"done": "Готово",
					"empty": "У вас еще нет подборок",
					"description": "Создайте подборки с новостройками для ваших клиентов и делитесь ими. В подборке будут видны только ваши контакты"
				},
				"contacts": {
					"empty": "Отсутствуют контакты застройщика",
					"contacts": "КОНТАКТЫ",
					"site": "Вебсайт",
					"showContacts": "Показать контакты"
				},
				"description": {
					"about": "О {{type}}",
					"readMore": "Читать дальше",
					"more": "Подробнее",
					"minimize": "Свернуть"
				},
				"developer": {
					"developer": "Застройщик",
					"contractor": "Ген. подрядчик",
					"noInfo": "Отсутствует информация о застройщике",
					"note": "Примечание",
					"commission": "Комиссия"
				},
				"documents": {
					"title": "Документы"
				},
				"features": {
					"today": "сегодня",
					"advantages": "Преимущества",
					"date": "Дата обновления информации о ЖК",
					"updated": "Обновлено",
					"showAll": "Показать все",
					"minimize": "Свернуть"
				},
				"formalization": {
					"zhiloeRoom": "Жилое помещение",
					"partFlat": "Доля в доме",
					"nezhiloeRoom": "Нежилое помещение",
					"apartmentRoom": "Квартира",
					"apartRoom": "Апартаменты",
					"zhiloeHouse": "Жилой дом",
					"commercialPremises": "Коммерческое помещение",
					"hotelRoom": "Гостиничный номер",
					"storageRoom": "Кладовое помещение",
					"parking": "Паркинг",
					"title": "Оформление",
					"label": "Варианты оформления",
					"type": "Тип недвижимости",
					"sum": "Сумма в договоре",
					"full": "Полная",
					"part": "Неполная"
				},
				"gallery": {
					"showAll": "Посмотреть все фото",
					"showOnMap": "На карте"
				},
				"housing": {
					"name": "Корпус {{name}}",
					"stopped": "Продажи остановлены",
					"soldAllHouses": "Проданы все дома от застройщика",
					"soldAllFlats": "Проданы все квартиры от застройщика",
					"flat1": "квартира",
					"flat2": "квартиры",
					"flat3": "квартир",
					"finished": "СДАН",
					"inProgress": "СТРОИТСЯ",
					"see": "Смотреть",
					"see1": "См.",
					"chess": "шахматку",
					"corps": "Корпуса {{number}}",
					"prices": "от {{areaMin}} м² до {{areaMax}} м², от {{costMin}} {{currency}} до {{costMax}} {{currency}}"
				},
				"info": {
					"paused": "Продажи приостановлены",
					"stopped": "Продажи остановлены",
					"house": "дом",
					"house1": "дома",
					"house2": "домов",
					"flat": "Квартира",
					"flat1": "Квартиры",
					"flat2": "Квартир",
					"soldAllHouses": "Все лоты проданы",
					"soldAllFlats": "Все лоты проданы",
					"minPrice": "{{minPrice}} {{currency}}",
					"price": "Мин. цена/м²",
					"cost": "Мин. цена",
					"area": "Площади, м²"
				},
				"leftWireframe": {
					"photo": "Фото",
					"info": "Информация о ЖК",
					"flats": "Квартиры",
					"advantages": "Преимущества",
					"commonAbout": "Общие характеристики",
					"about": "Характеристики",
					"com": "Коммуникации",
					"decor": "Оформление",
					"pay": "Оплата",
					"aboutHouse": "О ЖК",
					"corp": "Корпуса"
				},
				"nav": {
					"photo": "Фото",
					"info": "Информация о жк",
					"flats": "Квартиры",
					"tip": "Дата обновления информации о ЖК",
					"updated": "Обновлено"
				},
				"news": {
					"titleBig": "Новости {{title}}",
					"title": "Новости",
					"readMore": "Читать далее",
					"seeAll": "См. все новости"
				},
				"payment": {
					"ipoteka": "Ипотека",
					"installments": "Рассрочка",
					"military_ipoteka": "Военная ипотека",
					"mat_capital": "Материнский капитал",
					"taxes": "Возврат НДС",
					"cash": "Наличный расчет",
					"is_ipoteka_family": "Ипотека семейная",
					"is_ipoteka_state_support": "Ипотека с господдержкой",
					"is_ipoteka_it": "Ипотека IT",
					"is_ipoteka_tranche": "Ипотека траншевая",
					"is_ipoteka_subsidized": "Ипотека субсидированная",
					"is_ipoteka_preferential": "Ипотека льготная",
					"surcharge_balcony": "Доплата за балкон",
					"surcharge_communications": "Доплата за коммуникации",
					"surcharge_docs": "Доплата за документы",
					"surcharge_trash": "Доплата за вывоз мусора",
					"gas": "Доплата за газ",
					"pay": "Оплата",
					"price": "{{price}} {{currency}}"
				},
				"popup": {
					"photo": "фото"
				},
				"rightWireframe": {
					"social": "Я в социальных сетях",
					"builder": "Застройщик",
					"commission": "Комиссия",
					"contacts": "Контакты",
					"docs": "Документы"
				},
				"suggestions": {
					"jk": "Другие Объекты в микрорайоне {{subregion}}",
					"kp": "Другие ЖК в микрорайоне {{subregion}}"
				},
				"main": {
					"month": {
						"1": "Январь",
						"2": "Февраль",
						"3": "Март",
						"4": "Апрель",
						"5": "Май",
						"6": "Июнь",
						"7": "Июль",
						"8": "Август",
						"9": "Сентябрь",
						"10": "Октябрь",
						"11": "Ноябрь",
						"12": "Декабрь"
					},
					"onMap": "На карте",
					"lookOnMap": "Посмотреть на карте",
					"photo": "{{number}} из {{allNumber}}",
					"title": "{{title}} Информация о ЖК - Nedvex",
					"finished": "сдан",
					"inProgress": "СТРОИТСЯ",
					"allOnMap": "Посмотреть все фото ({{galleryImagesCount}})",
					"noViews": "Отсутствуют макеты жилого комплекса",
					"about": "Описание",
					"print": "Подготовка информации для печати..."
				},
				"printDialog": {
					"item": "Корпус {{pavilion}}, Секция {{section}}",
					"finished": "сдан",
					"inProgress": "СТРОИТСЯ",
					"print": "Печать",
					"info": "Информация о ЖК",
					"about": "Описание ЖК",
					"contacts": "Контакты застройщика",
					"chess": "Шахматки",
					"planning": "Планировки",
					"plans": "Корпус {{pavilionName}}, Секция {{section}}, этаж {{floor}}",
					"print1": "Распечатать"
				}
			}
		},
		"buildingCard": {
			"delete": "Удалить",
			"finished": "Сдан",
			"almostFinished": "Частично сдан",
			"flat1": "Квартира",
			"flat2": "Квартиры",
			"flat3": "Квартир",
			"lot": "Лот №{{id}}",
			"soldHouses": "Все лоты проданы",
			"soldFlats": "Все лоты проданы",
			"fromFull": "От {{costMin}} {{currency}}, от {{minAreaCost}} {{currency}} за м²",
			"costMin": "От {{costMin}} {{currency}}",
			"minAreaCost": "{{minAreaCost}} {{currency}} за м²",
			"goToObject": "Перейти к ЖК"
		},
		"buildings": {
			"filterLabel": {
				"blackList": "Объект самовольного строительства",
				"new": "Новинка",
				"nedvex": "Nedvex"
			},
			"list": {
				"verified": "Верифицированный Объект",
				"house1": "дом",
				"house2": "дома",
				"house3": "домов",
				"flat1": "квартира",
				"flat2": "квартиры",
				"flat3": "квартир",
				"stopped": "ПРОДАЖИ ОСТАНОВЛЕНЫ",
				"byPromo": "По акции",
				"byQuery": "Под ваш запрос",
				"removeFromFavorites": "Убрать ЖК из избранного",
				"addToFavorites": "Добавить ЖК в избранное",
				"alreadyInFavorites": "В избранном",
				"addTo": "В избранное",
				"addToCollection": "Добавить ЖК в подборку",
				"toCollection": "В подборку",
				"promo": "Акция",
				"promoAds": "Реклама",
				"finished": "СДАН",
				"almostFinished": "ЧАСТИЧНО СДАН",
				"inProgress": "СТРОИТСЯ",
				"beforeAgr": "Пред. договор",
				"military_ipoteka": "Воен. Ипот.",
				"mat_capital": "Мат. кап.",
				"ipoteka": "Ипотека",
				"installments": "Рассрочка",
				"paused": "Продажи<br />приостановлены",
				"costMin": "От {{costMin}} {{currency}}",
				"minAreaCost": "От {{minAreaCost}} {{currency}} за м²",
				"chess": "Шахматка",
				"square": "{{square}} м²",
				"square12": "{{square1}} м² - {{square2}} м²",
				"stopped2": "Продажи остановлены",
				"soldHouses": "Все дома<br />от застройщика<br />проданы",
				"soldFlats": "Все<br />лоты<br />проданы"
			},
			"news": {
				"title": "Лента новостей",
				"readMore": "Читать далее",
				"all": "Все",
				"favorite": "Избранное",
				"fromService": "От сервиса"
			},
			"noBuildings": {
				"startNewSearch": "Начать новый поиск",
				"notFound": "Не найдено объектов",
				"notFoundFull": "Мы не нашли объектов под ваш запрос. <br /> Попробуйте изменить ваш запрос или начните новый поиск"
			},
			"buildings": {
				"sorts": {
					"date_updateDESC": "дате",
					"cost_minASC": "увеличению цены",
					"cost_minDESC": "уменьшению цены",
					"title": "названию"
				},
				"typeFiltersInfo": {
					"nedvex": "NEDVEX",
					"new": "Новинки",
					"promo": "Акции",
					"orderField": "Популярные"
				},
				"searchResults": "Результаты поиска",
				"cottegesPage": "КП и ТХ {{conjunction}} {{city}}",
				"new": "Новостройки {{conjunction}} {{city}}",
				"newShort": "Новостройки",
				"map": "Карта",
				"clear": "Сбросить",
				"filters": "фильтры",
				"search1": "Найден",
				"search2": "Найдено",
				"search3": "Найдено",
				"new1": "объект",
				"new2": "объекта",
				"new3": "объектов",
				"object1": "объект",
				"object2": "объекта",
				"object3": "объектов",
				"by": "По",
				"sortList": "Сортировка списка ЖК",
				"searchOnMap": "Карта",
				"onMap": "На карте",
				"searchOnList": "Искать на списке",
				"day": "ДЕНЬ",
				"week": "НЕДЕЛЯ",
				"month": "МЕСЯЦ"
			}
		},
		"clientCollection": {
			"noPageTitle": "Страница была удалена или не существует",
			"noPageSubTitle": "Если вы получили эту ссылку для ознакомления - сообщите отправителю об ошибке.",
			"district": "району",
			"costMinASC": "увеличению цены",
			"costMinDESC": "уменьшению цены",
			"sort": "Сортировка списка ЖК",
			"searchOnMap": "Искать на карте",
			"map": "Карта"
		},
		"collection": {
			"title": "{{name}} - Подборка - Nedvex",
			"myCollections": "Мои подборки",
			"sendCollection": "Поделиться",
			"sendLink": "Отправляйте ссылку на подборку клиентам",
			"copy": "Скопировать",
			"copied": "Ссылка скопирована",
			"emptyCollection": "Пустая подборка",
			"description": "Создайте подборки с новостройками для ваших клиентов и делитесь ими. В подборке будут видны только ваши контакты",
			"goToList": "Перейти к списку объектов"
		},
		"collectionItem": {
			"lot": "Лот №{{buildingId}}",
			"finished": "Сдан",
			"almostFinished": "Частично сдан",
			"addComment": "Добавить комментарий",
			"comment": "Комментарий",
			"delete": "Удалить",
			"writeComment": "Введите текст комментария и нажмите Enter",
			"cancel": "Отменить",
			"edit": "Редактировать",
			"save": "Сохранить"
		},
		"collections": {
			"title": "Подборки - Nedvex",
			"myCollections": "Мои подборки",
			"create": "Создать подборку",
			"noCollections": "У вас еще нет подборок",
			"share": "Создайте подборки с новостройками для ваших клиентов и делитесь ими. В подборке будут видны только ваши контакты",
			"enterName": "Введите название подборки",
			"collection1": "подборка",
			"collection2": "подборки",
			"collection3": "подборок"
		},
		"collectionsItem": {
			"rename": "Переименовать",
			"description": "{{total}} ЖК",
			"dup": "Дублировать",
			"del": "Удалить",
			"cancel": "Отмена",
			"deleteCollection": "Удаление подборки",
			"sure": "Вы уверены, что хотите удалить подборку {{name}}?"
		},
		"collectionsPopup": {
			"title": "Создать подборку",
			"enter": "Введите название подборки",
			"add": "Сохранить"
		},
		"common": {
			"radioMenu": {
				"select": "Выберите район",
				"clear": "СБРОСИТЬ",
				"selectAll": "ВЫБРАТЬ ВСЕ"
			},
			"yPlaceInfo": {
				"promo": "Акция",
				"stopped": "Продажи остановлены",
				"addToCollection": "В подборку",
				"finished": "СДАН",
				"almostFinished": "ЧАСТИЧНО СДАН",
				"inProgress": "СТРОИТСЯ",
				"flat1": "Квартира",
				"flat2": "Квартиры",
				"flat3": "Квартир",
				"square": "{{minSquare}} м² - {{maxSquare}} м²",
				"costMin": "От {{costMin}} {{currency}}",
				"minAreaCost": "{{minAreaCost}} {{currency}} за м²",
				"soldHouses": "Все лоты проданы",
				"soldFlats": "Все лоты проданы",
				"inFavorite": "В избранном",
				"addToFavorite": "В избранное"
			}
		},
		"favorites": {
			"title": "Избранное - Nedvex",
			"titleBlock": "Избранное",
			"count1": "новостройка",
			"count2": "новостройки",
			"count3": "новостроек",
			"remove": "Удалить из избранного",
			"empty": "У вас в избранном еще ничего нет",
			"notFound": "Добавляйте новостройки в избранное и они будут видны здесь"
		},
		"flatsList": {
			"filters": {
				"price": "Стоимость, {{currency}}",
				"area": "Площадь, м²",
				"from": "от",
				"to": "до",
				"interior": "Отделка"
			},
			"flats": {
				"showMore": "Показать еще"
			},
			"flatListItem": {
				"gallery": {
					"modalName": "Планировка",
					"floor": "{{floor}} этаж"
				},
				"number": "{{number}} этаж",
				"reserved": "Квартира зарезервирована<br />застройщиком",
				"sold": "Квартира продана",
				"promo": "Акция",
				"reserve": "Бронь",
				"priceFormatted": "{{priceFormatted}} {{currency}} за м²",
				"area": "{{area}} м²",
				"predChistInt": "Пред. чистовая",
				"housing": "Корпус {{pavilionName}}, секция {{sectionName}}",
				"showPlan": "См. планировку этажа",
				"flatNumber": "№ квартиры",
				"price": "Цена за м²",
				"inner": "Отделка",
				"finished": "Сдан",
				"emptyPlan": "Отсутствует планировка этажа"
			},
			"subFilters": {
				"flat1": "квартира",
				"flat2": "квартиры",
				"flat3": "квартир",
				"sort": "Сортировать по {{sort}}"
			},
			"flatsList": {
				"sorts": {
					"priceAllAsc": "увеличению цены",
					"priceAllDesc": "уменьшению цены",
					"areaAsc": "увеличению площади",
					"areaDesc": "уменьшению площади",
					"area": "{{area}} м²",
					"price": "{{price}} ₽/м²"
				},
				"flat1": "Квартира",
				"flat2": "Квартиры",
				"flat3": "Квартир",
				"notFound": "Нет подходящий квартир под ваш запрос",
				"startNewSearch": "Начать новый поиск",
				"soldOut": "Все квартиры проданы",
				"noForSale": "Нет квартир в продаже",
				"soldAllHouses": "Проданы все дома от застройщика",
				"soldAllFlats": "Проданы все квартиры от застройщика"
			}
		},
		"footer": {
			"innKpp": "ИНН 2318043183<br/>ОГРН 1162366056830",
			"address": "354000, Краснодарский край, <br/>г. Сочи, пер. Морской, 1/1а",
			"softDeveloper": "ООО “Недвекс” является разработчиком <br> программного обеспечения",
			"copied": "Все права защищены. 2025",
			"docs": "Документы"
		},
		"header": {
			"buildingTitle": {
				"verified": "Верифицированный Объект",
				"finished": "сдан",
				"almostFinished": "ЧАСТИЧНО СДАН",
				"inProgress": "СТРОИТСЯ",
				"today": "Сегодня",
				"lot": "Лот №{{id}}",
				"promo": "АКЦИЯ",
				"updatedAt": "Дата обновления информации о ЖК",
				"updatedFrom": "Информация от",
				"addToFavorites": "Добавить ЖК в избранное",
				"share": "Поделиться ссылкой на объект",
				"print": "Печать информации о ЖК"
			},
			"clientHeader": {
				"address": "Адрес",
				"phone": "Телефон",
				"mail": "Эл. почта",
				"website": "Вебсайт",
				"backToList": "ВЕРНУТЬСЯ К СПИСКУ"
			},
			"filtersBar": {
				"filters": {
					"viewTypes": {
						"title": "Вид из окна",
						"chooseViewType": "Выберите вид из окна",
						"clear": "СБРОСИТЬ",
						"notSelected": "Не выбрано"
					},
					"advantages": {
						"title": "Преимущества",
						"clear": "СБРОСИТЬ",
						"parking": "Паркинг",
						"elevator": "Лифт",
						"concierge": "Консьерж",
						"childrenArea": "Детская площадка",
						"recreationZone": "Зона отдыха",
						"pool": "Бассейн",
						"beach": "Пляж",
						"restaurant": "Ресторан",
						"operatedRoof": "Эксплуатационная кровля",
						"new": "Новинка",
						"zbbq": "Зона барбекю",
						"walkingArea": "Прогулочные зоны",
						"wellnessBuilding": "Оздоровительный корпус",
						"houseTerritory": "Закрытая территория",
						"spa": "SPA",
						"cctv": "Видеонаблюдение",
						"commercialProperty": "Коммерческие площади",
						"sportArea": "Спортивная площадка",
						"kpp": "КПП"
					},
					"area": {
						"title": "Укажите площадь",
						"clear": "СБРОСИТЬ",
						"from": "от",
						"fromFull": "Площадь от",
						"to": "до",
						"toFull": "Площадь до",
						"notSelected": "Не выбрано"
					},
					"buildingClass": {
						"variant1": "Эконом",
						"variant2": "Комфорт",
						"variant3": "Бизнес",
						"variant4": "Элит",
						"notSelected": "Не выбрано",
						"title": "Класс дома",
						"clear": "СБРОСИТЬ"
					},
					"deadline": {
						"title": "Выберите срок сдачи",
						"clear": "СБРОСИТЬ",
						"finished": "Дом сдан",
						"quarter": "{{data}} квартал",
						"notSelected": "Не выбрано",
						"deadlineEnd": "Дом сдан"
					},
					"decoration": {
						"clear": "СБРОСИТЬ",
						"title": "Отделка",
						"titleFull": "Отделка",
						"chernInt": "Черновая",
						"chistInt": "Чистовая",
						"predChistInt": "Пред. чистовая",
						"whiteBox": "White box",
						"repair": "Ремонт, мебель, техника",
						"remInt": "Ремонт",
						"chastRemInt": "Частичный ремонт",
						"notSelected": "Не выбрано"
					},
					"interior": {
						"chernInt": "Черновая",
						"chistInt": "Чистовая",
						"whiteBox": "White box",
						"repair": "Ремонт, мебель, техника",
						"predChistInt": "Пред. чистовая",
						"remInt": "Ремонт",
						"chastRemInt": "Частичный ремонт",
						"notSelected": "Не выбрано",
						"title": "Выберите тип отделки",
						"clear": "СБРОСИТЬ"
					},
					"payment": {
						"title": "Варианты оплаты",
						"clear": "СБРОСИТЬ",
						"notSelected": "Не выбрано",
						"taxes": "Возврат НДС",
						"cash": "Наличный расчет",
						"installments": "Рассрочка",
						"mat_capital": "Материнский капитал",
						"ipoteka": "Ипотека",
						"military_ipoteka": "Военная ипотека",
						"is_ipoteka_family": "Ипотека семейная",
						"is_ipoteka_state_support": "Ипотека с господдержкой",
						"is_ipoteka_it": "Ипотека IT",
						"is_ipoteka_tranche": "Ипотека траншевая",
						"is_ipoteka_subsidized": "Ипотека субсидированная",
						"is_ipoteka_preferential": "Ипотека льготная"
					},
					"price": {
						"cost": "{{price}} млн.",
						"perMeter": "{{min}} - {{max}} за м²",
						"notSelected": "Не выбрано",
						"clear": "СБРОСИТЬ",
						"title": "Укажите цену",
						"from": "Цена от",
						"to": "Цена до",
						"commonPrice": "Общая цена",
						"commonPriceMeter": "Цена за м²",
						"commonPriceWithCurrency": "Общая цена, {{currency}}",
						"commonPriceMeterWithCurrency": "Цена за м², {{currency}}"
					},
					"federalLaw": {
						"fz214": "ФЗ-214",
						"fz215": "ФЗ-215",
						"notSelected": "Не выбрано",
						"clear": "СБРОСИТЬ",
						"title": "Федеральный закон"
					},
					"registration": {
						"fz214": "ФЗ-214",
						"fz215": "ФЗ-215",
						"ust": "Юстиция",
						"inv": "Договор инвестирования",
						"part": "ДДУ / ФЗ-214",
						"buySale": "Договор купли-продажи",
						"contract": "Договор подряда",
						"prec": "Предварительный договор",
						"shared": "Паевой взнос",
						"reserv": "Договор бронирования",
						"loan": "Договор займа",
						"partnership": "Договор простого товарищества",
						"assignment": "Договор переуступки",
						"notSelected": "Не выбрано",
						"clear": "СБРОСИТЬ",
						"title": "Выберите тип оформления"
					},
					"sea": {
						"500": "До 500 м",
						"1500": "До 1500 м",
						"3000": "До 3000 м",
						"notSelected": "Не выбрано",
						"clear": "СБРОСИТЬ",
						"title": "Расстояние до моря"
					},
					"type": {
						"flat": "Квартира",
						"apt": "Апартаменты",
						"lvn": "Жилое помещение",
						"nlvn": "Нежилое помещение",
						"hotelRoom": "Гостиничный номер",
						"zhiloeHouse": "Жилой дом",
						"storageRoom": "Кладовое помещение",
						"notSelected": "Не выбрано",
						"clear": "СБРОСИТЬ",
						"title": "Тип недвижимости"
					},
					"districtTitle": "Район",
					"priceTitle": "Цена",
					"areaTitle": "Площадь",
					"registrationTitle": "Оформление",
					"deadlineTitle": "Срок сдачи",
					"paymentTitle": "Варианты оплаты",
					"moreTitle": "Еще"
				}
			},
			"regionPopup": {
				"title": "Выберите страну"
			},
			"search": {
				"title": "Поиск"
			},
			"user": {
				"tarif": "Тариф «{{tarif}}»",
				"day1": "день",
				"day2": "дня",
				"day3": "дней",
				"withClient": "Я с клиентом",
				"profile": "Профиль",
				"myProfile": "Мой профиль",
				"companyProfile": "Профиль компании",
				"logout": "Выйти",
				"withClient2": "С клиентом"
			},
			"menu": {
				"building": "Жилые комплексы",
				"kpAndTh": "КП и ТХ",
				"collections": "Подборки",
				"favorites": "Избранное"
			}
		},
		"login": {
			"formRegistration": {
				"workOptions1": "Частный агент",
				"workOptions2": "Работаю в агентстве недвижимости",
				"workOptions3": "Хочу подключить свое агенство",
				"title": "Регистрация в приложении Nedvex",
				"nameError": "Некорректно введено имя",
				"name": "Ваше имя",
				"surNameError": "Некорректно введена фамилия",
				"surName": "Ваша фамилия",
				"currentWork": "Выберите ваше место работы:",
				"currentWorkError": "Выберите вашу должность",
				"city": "Выберите город:",
				"cityError": "Выберите город",
				"phoneNumberError": "Некорректно введен номер телефона",
				"emailError": "Некорректно введен e-mail",
				"email": "Введите ваш e-mail",
				"send": "ОТПРАВИТЬ",
				"agree": "Нажимая на кнопку «Отправить» Вы соглашаетесь с нашей ",
				"politicianLink": "Политикой конфиденциальности",
				"eulaLink": "Пользовательским соглашением."
			},
			"formNumber": {
				"userNotFound": "Телефон не зарегистрирован",
				"serverError": "Ошибка сервера, попробуйте позже",
				"title": "Вход в приложение Nedvex",
				"button": "ВОЙТИ",
				"registration": "ЗАРЕГИСТРИРОВАТЬСЯ"
			},
			"formSMS": {
				"title": "Вход на сайт",
				"smsError": "Неправильный код авторизации",
				"sms": "Пожалуйста, введите код из SMS",
				"remainingTime": "Попробуйте через {{remainingTime}} сек",
				"submit": "Подтвердить",
				"resend": "Отправить код повторно"
			},
			"formTechnicalProblem": {
				"title": "Технические неполадки<br />Попробуйте позже"
			}
		},
		"notification": {
			"text": "Скачайте инсайты по рынку сочинской недвижимости от экспертов Nedvex, пройдя короткий опрос.",
			"link": "https://forms.yandex.ru/cloud/67221d87068ff05dd791691f",
			"textEnding": "и узнайте, как увеличить продажи в новом регионе",
			"cancel": "Отменить"
		},
		"payments": {
			"failPage": {
				"title": "Ошибка оплаты",
				"description": "К сожалению, мы не смогли принять ваш платеж.<br />Попробуйте еще раз.",
				"tryMore": "Попробовать еще раз"
			},
			"notification": {
				"title": "{{days}} до окончания {{tarif}} {{agencyName}}",
				"company": "платной подписки",
				"personal": "платной подписки",
				"company_test": "бесплатного тестового периода",
				"personal_test": "бесплатного тестового периода",
				"default": "бесплатного тестового периода",
				"day1": "день",
				"day2": "дня",
				"day3": "дней"
			},
			"payForTarif": {
				"title": "ВЫБОР ПОДПИСКИ",
				"subtitle": "Оставшиеся дни сохраняются после оплаты",
				"tarifImg": "Тариф «Частный»",
				"tarifSolo": "Тариф «Индивидуальный»",
				"description": "Ваш личный доступ к сервису",
				"popular": "Популярное",
				"price": "2000 ₽",
				"time": "1 месяц",
				"pay": "Оплатить подписку",
				"text": "Оставшиеся дни сохранятся <br />после оплаты",
				"button": "Оплатить",
				"months": {
					"1": "на 1 месяц",
					"3": "на 3 месяца",
					"12": "на 12 месяцев"
				}
			},
			"subscriptionBar": {
				"title": "{{countDay}} {{left}}",
				"day1": "день",
				"day2": "дня",
				"day3": "дней",
				"left1": "остался",
				"left2": "осталось",
				"left3": "осталось",
				"ended": "Закончилась подписка",
				"tarif": "Тариф: «{{tarif}}»",
				"workers": "{{workersCount}} из {{countPeople}} сотрудников",
				"text": "Оставшиеся дни сохранятся <br />после оплаты"
			},
			"successPage": {
				"title": "Успешная оплата",
				"description": " Вы успешно оплатили подписку. Спасибо! <br />Доступ к сервису восстановлен.",
				"goToMain": "Вернуться на главную"
			}
		},
		"profile": {
			"avatar": {
				"update": "Обновить фото",
				"upload": "Загрузить фото"
			},
			"tariffModal": {
				"title": "Выбрать тариф",
				"button": "Сформировать счет",
				"current": "текущий тариф",
				"error": {
					"title": "что-то пошло не так",
					"default": "При формировании счёта возникла ошибка. Повторите попытку через несколько минут.",
					"data": "При формировании счета возникла ошибка. Проверьте корректность введенных ИНН и КПП.",
					"count": "Вам необходимо уменьшить кол-во сотрудников до {{count}}."
				},
				"emptyInnOrKpp": {
					"title": "Ошибка",
					"body": "Необходимо заполнить ИНН и КПП"
				}
			},
			"avatarUploader": {
				"title": "Ваше фото",
				"button": "Обрезать и сохранить"
			},
			"employeeList": {
				"new": "Новый сотрудник",
				"deny": "Вы не можете добавить еще одного сотрудника в рамках текущего тарифного плана.",
				"allow": "Вы можете добавить еще {{countPeople}} сотрудников",
				"admin": "Администратор",
				"edit": "Редактировать",
				"delete": "Удалить",
				"cancel": "Отмена",
				"deleteWorker": "Удаление сотрудника",
				"areYouSure": "Вы уверены что хотите удалить сотрудника {{firstName}} {{lastName}}?"
			},
			"profileForm": {
				"saveButton": "Сохранить изменения",
				"logout": "Выйти из аккаунта",
				"leaveAgency": "Выйти из агентства",
				"firstName": "Имя",
				"firstNameLabel": "Иван",
				"lastName": "Ваша фамилия",
				"lastNameLabel": "Иванов",
				"phone": "Телефон",
				"email": "Электронная почта",
				"position": "Должность",
				"positionPlaceholder": "example@gmail.com",
				"company": "Компания",
				"companyPlaceholder": "Название компании",
				"about": "Расскажите о себе",
				"aboutPlaceholder": "Введите текст до 250 символов",
				"profileLink": "Ссылка на профиль",
				"vk": "Вконтакте",
				"ok": "Одноклассники",
				"validate": {
					"firstName": "Введите имя",
					"firstNameError": "Слишком длинное имя",
					"lastName": "Введите фамилию",
					"lastNameError": "Слишком длинная фамилия",
					"phone": "Введите телефон",
					"phoneConflict": "Номер уже зарегистрирован, обратитесь в поддержку",
					"phoneError": "Неверный телефон",
					"email": "Введите адрес",
					"emailError": "Неверный адрес",
					"emailError1": "Слишком длинный адрес",
					"emailConflict": "Почта уже зарегистрирована, обратитесь в поддержку",
					"position": "Введите должность",
					"positionError": "Слишком длинная должность",
					"positionError1": "Введите текст до 250 символов"
				},
				"leaveAgencyDialog": {
					"title": "Выйти из агентства?",
					"subtitle": "После выхода из агентства вы потеряете доступ к платформе. Вам нужно будет   оформить личную подписку или перейти в другое агентство",
					"leave": "Выйти",
					"cancel": "Отмена"
				},
				"informPopup": {
					"userBindedToAgencyTitle": "Пользователь привязан к другому агентству",
					"userBindedToAgencySubtitle": "Для того чтобы добавить пользователя в ваше агентство, ему необходимо выйти из своего текущего агентства",
					"userBindedToAgencyButton": "Хорошо",
					"userAlreadyExistsTitle": "Агент с таким номером уже есть",
					"userAlreadyExistsSubtitle": "Добавить его в карточку агентства?",
					"userAlreadyExistsButton": "Добавить"
				}
			},
			"company": {
				"validate": {
					"name": "Введите название компании",
					"nameError": "Слишком длинное название компании",
					"description": "Введите текст до 500 символов",
					"officeErrors1": "Введите название офиса",
					"officeErrors2": "Слишком длинное название офиса",
					"address": "Введите адрес",
					"phone": "Введите телефон",
					"email": "Введите электронную почту",
					"emailError": "Слишком длинный адрес",
					"inn": "Введите ИНН компании",
					"kpp": "Введите КПП компании"
				},
				"mainOffice": "Главный офис",
				"anotherOffice": "Дополнительный офис",
				"officeName": "Название офиса",
				"officeNamePlaceholder": "Офис в Сочи",
				"officeAddress": "Адрес офиса",
				"officeAddressPlaceholder": "Сочи, ул. Кооперативная, 8",
				"officePhone": "Телефон",
				"officeEmail": "Электронная почта",
				"plusOffice": "+ ДОПОЛНИТЕЛЬНЫЙ ОФИС",
				"title": "Профиль компании",
				"commonInfo": "Общая Информация",
				"workers": "Сотрудники",
				"form": {
					"name": "Название компании",
					"website": "Вебсайт",
					"description": "Описание компании",
					"inn": "ИНН",
					"kpp": "КПП"
				},
				"socialNets": "Социальные сети",
				"save": "Сохранить изменения"
			},
			"employerInteraction": {
				"edit": "Редактировать профиль",
				"new": "Новый сотрудник"
			},
			"profile": {
				"noPermission": "Чтобы изменить контактные данные обратитесь к администратору",
				"title": "Редактировать профиль",
				"profileTab": "MОИ ДАННЫЕ",
				"appointmentsTab": "МОИ ЗАПИСИ"
			},
			"appointments": {
				"futureAppointments": "БУДУЩИЕ",
				"pastAppointments": "ПРОШЕДШИЕ",
				"noAppointments": "Нет записей",
				"noFutureAppointments": "Вы еще не записались на показ объектов",
				"noPastAppointments": "Вы еще не проводили показ объектов",
				"dateAndTime": "Дата и время",
				"clientName": "Имя клиента",
				"clientDate": "Телефон клиента",
				"comment": "Комментарий",
				"agentName": "Имя агента",
				"agency": "Агентство"
			}
		},
		"realtorCard": {
			"title": "Я в социальных сетях",
			"in": "в"
		},
		"realtorPopup": {
			"office": "Офис",
			"onMap": "На карте",
			"minMap": "Свернуть карту",
			"showMap": "Показать карту",
			"phone": "Телефон",
			"address": "Адрес",
			"email": "Эл. почта",
			"website": "Вебсайт"
		},
		"searchFullscreen": {
			"constants": {
				"all1": "Введите название ЖК, района, улицы",
				"all2": "Введите название",
				"regions": "Введите название района",
				"sub_regions": "Введите название микрорайона",
				"buildings": "Введите название новостройки",
				"streets": "Введите название улицы"
			},
			"filters": {
				"all": "все",
				"buildings": "Новостройки",
				"areas": "Районы",
				"neighborhoods": "Микрорайоны",
				"streets": "Улицы"
			},
			"all": "все",
			"buildings": "Новостройки",
			"areas": "Районы",
			"neighborhoods": "Микрорайоны",
			"streets": "Улицы",
			"emptyResults": "Ничего не найдено",
			"emptyResultsDescription": "Мы ничего не нашли по вашему запросу"
		},
		"shareDialog": {
			"sendObject": "Отправить объект",
			"title": "Какие разделы будут видны по ссылке",
			"hint": "Отправляйте ссылку на объект клиентам",
			"copy": "Скопировать",
			"copied": "Ссылка скопирована",
			"savePdfFile": "Скачать презентацию"
		},
		"typeFilters": {
			"new": "Новинки",
			"promo": "Акции",
			"popular": "Популярные"
		}
	},
	"containers": {
		"logIn": {
			"title-phone": "Авторизация",
			"title-code": "Ввод кода",
			"subtitle-phone": "Введите номер телефона",
			"subtitle-code": "Код",
			"hint-phone-call": "Вам поступит звонок от робота. Можете<br/>не отвечать на него, запомните последние<br/>4 цифры",
			"hint-code-call": "Введите последние 4 цифры номера, с которого вам позвонил робот",
			"hint-phone-sms": "Укажите номер вашего телефона. На него поступит смс-сообщение с кодом для авторизации",
			"hint-code-sms": "Введите 5 цифр из SMS",
			"recall": "Отправить звонок повторно можно через {{sec}} сек.",
			"resend": "Отправить код повторно можно через {{sec}} сек.",
			"doRecall": "Отправить звонок повторно",
			"doResend": "Отправить код повторно",
			"error-code-phone": "Последние 4 цифры, звонившего номера телефона введены неверно",
			"error-code-sms": "Неверный код из SMS-сообщения. Попробуйте еще раз",
			"registration": "Нет аккаунта? Зарегистрируйтесь",
			"buttons": {
				"continue": "Продолжить",
				"bySms": "Войти по SMS",
				"byCall": "Войти по звонку",
				"enter": "Войти",
				"back": "Назад"
			},
			"description": {
				"1": "Платформа",
				"2": "недвижимости Сочи"
			},
			"footer": {
				"privacy": "Политика конфиденциальности",
				"eula": "Пользовательское соглашение",
				"inn": "ИНН 2318043183",
				"ogrn": "ОГРН 1162366056830",
				"copyright": "{{year}}. Все права защищены"
			},
			"technicalProblem": {
				"title": "Что-то пошло не так",
				"phone-call": "Не удалось отправить исходящий звонок, попробуйте другой способ входа — «Войти по SMS»",
				"phone-sms": "Не удалось отправить код по SMS, попробуйте другой способ входа — «Войти по звонку»"
			}
		},
		"login": {
			"title1": "Платформа недвижимости Сочи",
			"title2": "для агентов и агентств недвижимости",
			"tariffs": "Тарифы",
			"phone1": "8 (968) 3000 112",
			"phone1Link": "89683000112",
			"phone2": "8 (968) 3001 220",
			"phone2Link": "89683001220",
			"description1": "Самая большая и актуальная база новостроек",
			"description2": "Сочи с возможностью формировать подборки для ваших клиентов",
			"about1": "активных риэлторов в месяц пользуются нашим сервисом",
			"about2": "агентств недвижимости Сочи пользуются нашей платформой",
			"about3": "актуальных объектов недвижимости в базе приложения",
			"about4": "параметров по каждому объекту",
			"footer1": "ИНН 2318043183<br/>ОГРН 1162366056830",
			"footer2": "ООО “Недвекс” является разработчиком <br> программного обеспечения",
			"footer3": "Все права защищены. 2025",
			"docs": "Документы"
		}
	},
	"epics": {
		"addedToCollections1": "{{buildingName}} добавлен в подборки",
		"removeFromCollections1": "{{buildingName}} удалён из подборок",
		"addedToCollections2": "{{buildingName}} добавлен в подборку «{{collectionName}}»",
		"removeFromCollections2": "{{buildingName}} удалён из подбороки «{{collectionName}}»",
		"emptyFieldsError": "Не заполнены обязательные поля",
		"fieldsError": "Поля заполнены некорректно",
		"savedInfo": "Информация сохранена",
		"leavedFromAgency": "Вы вышли из агентства",
		"leaveAgencyError": "Не удалось выйти из агентства",
		"deletedCollection": "Подборка удалена",
		"registrationSuccessTitle": "Заявка успешно отправлена!",
		"registrationSuccessSubtitle": "Спасибо! Наш менеджер свяжется с вами для уточнения информации",
		"addedToFavorites": "{{buildingName}} добавлен в избранное",
		"deleteFromFavorites": "{{buildingName}} удалён из избранного",
		"loadCalendarError": "Не удалось записаться. Попробуйте зайти позже",
		"loadAppointmentStatusesError": "Не удалось перейти в Мои записи. Попробуйте зайти позже"
	},
	"utils": {
		"formatDate": {
			"today": "Сегодня",
			"yesterday": "Вчера"
		},
		"getTarifName": {
			"company": "Агентский",
			"personal": "Индивидуальный",
			"test": "Тестовый"
		},
		"getTarifPeriodName": {
			"company": "Оплаченный",
			"test": "Тестовый"
		},
		"monthToString": {
			"0": "января",
			"1": "февраля",
			"2": "марта",
			"3": "апреля",
			"4": "мая",
			"5": "июня",
			"6": "июля",
			"7": "августа",
			"8": "сентября",
			"9": "октября",
			"10": "ноября",
			"11": "декабря"
		},
		"updateString": {
			"todayAt": "Сегодня в {{time}}"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ru.json
// module id = 1640
// module chunks = 0